import { useGroupTableSelection } from '@/components/group-tables/use-group-table-selection';
import { createLocalSelectionSyncAdapter } from '@/components/group-tables/selection-sync-adapter';

type SelectableBrandGroup = {
    id: string;
};

type UseBrandsTableSelectionArgs = {
    pickedBrandGroups: string[];
    setPickedBrandGroups?: (value: string[]) => void;
    maxSelectedItems: number | null;
    visibleBrandGroups: SelectableBrandGroup[];
    pagedBrandGroups: SelectableBrandGroup[];
};

export const useBrandsTableSelection = ({
    pickedBrandGroups,
    setPickedBrandGroups,
    maxSelectedItems,
    visibleBrandGroups,
    pagedBrandGroups,
}: UseBrandsTableSelectionArgs) => {
    const selectionSync = createLocalSelectionSyncAdapter({
        setPickedIds: setPickedBrandGroups,
    });

    return useGroupTableSelection<SelectableBrandGroup>({
        pickedIds: pickedBrandGroups,
        setPickedIds: selectionSync.setPickedIds,
        maxSelectedItems,
        visibleItems: visibleBrandGroups,
        pagedItems: pagedBrandGroups,
    });
};
